import { useMutation, useQueryClient } from "@tanstack/react-query";
import { lockMatch, unlockMatch } from "@/api/matches";
import { MatchesQueryKeys } from "@/tanstackQuery/queries/matches";
import { invalidateMatchLists } from "./invalidateMatchLists";

export const useLockMatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (matchId: string) => lockMatch(matchId),
    onSuccess: () => {
      invalidateMatchLists(queryClient);
    },
  });
};

export const useUnlockMatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (matchId: string) => unlockMatch(matchId),
    onSuccess: () => {
      invalidateMatchLists(queryClient);
    },
  });
};
